import LRU from 'lru-cache'
import getIcons from '@/config/icons'

const themeCache = new LRU({
  max: 10,
  ttl: 1000 * 60 * 60
})

export default {
  font: false,
  icons: {
    values: { ...getIcons }
  },
  breakpoint: {
    sm: 600,
    md: 960,
    lg: 1264,
    xl: 1440,

    thresholds: {
      sm: 960,
      md: 1264,
      lg: 1440
    }
  },
  theme: {
    dark: false,
    options: {
      cspNonce: 'dQw4w9WgXcQ',
      themeCache,
      minifyTheme(css) {
        return process.env.NODE_ENV === 'production' ? css.replace(/[\r\n|\r|\n]/g, '') : css
      }
    }
  }
}
